import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { ButtonHeading, CityDropdownForTrip, CommonInput, CommonModal, CustomPagination, CustomSelect } from 'components'
import { deleteConsignorData } from '_services/accountsServices/consignorServices';
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { deleteZoneData, getZoneListData } from '_services/accountsServices/zoneServices';

import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import MastersFilterModal from 'modals/MastersFilterModal';
import { constant } from 'constants/constant';
import { deleteVehicleGroupData, getVehicleGroupListData } from '_services/accountsServices/vehicleGroupServices';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import AddEditVehicleDocTypeModel from 'modals/AddEditVehicleDocTypeModel/AddEditVehicleDocTypeModel';
import { deleteVehicleDocData, getVehicleDocTypeListData } from '_services/accountsServices/vehicleDocTypeServices';
import { CiLock, CiUnlock } from 'react-icons/ci';
import { deleteManufacturer, deleteStore, getManufacturerList, getPartCategoryList, getStoreList } from '_services/workShopServices/workShopServices';
import AddEditStoreModel from 'modals/AddEditStoreModel';
import { AddEditManufacturerModel } from 'modals';
import { utils } from 'helper';

const Manufacturer = () => {
  useDocumentTitle("Workshop Manufacturer | T360");

  const { settingChild } = useContext(UserContext);
  const settingChildVehicleGrp = settingChild?.find((i) => i?.label === "Vehicle Group");
  const [manufacturerModelData, setManufacturerModelData] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [manufacturerDataList, setManufacturerDataList] = useState([])
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const prevFilterRef = useRef();
  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: '',
    category_id: ''
  });

  const toggleStoreModelData = () => {
    setManufacturerModelData(!manufacturerModelData);
  };

  const getDataManufacturerList = async () => {
    try {
      let object = {
        ...filter,
        category_id: filter?.category_id?.value,
        company_id: StorageService.getCompanyId(),
      }
      const res = await getManufacturerList(object);
      if (res?.responseCode == 200) {
        setManufacturerDataList(res?.data?.manufactureData);
        setTotalItems(res?.data?.total_record);
      }
    } catch (error) {
      // throw error;
    }
  }

  useEffect(() => {
    const prevFilter = prevFilterRef.current;
    if (
      JSON.stringify(prevFilter) !== JSON.stringify(filter)
    ) {
      getDataManufacturerList();
      prevFilterRef.current = filter;
    }
  }, [filter, manufacturerModelData])

  const deleteHandler = (item) => {
    setIsDelete(item)
  }

  const submitDeleteStore = async (itemData) => {
    setLoading(true);
    try {
      let object = {}
      if (itemData?.disable) {
        object['id'] = itemData?._id;
        object['status'] = (itemData?.status === 1) ? 3 : 1;
      } else {
        object['id'] = isDelete?._id;
        object['status'] = 2;
      }
      const res = await deleteManufacturer(object);
      if (res?.responseCode == 200) {
        toast.success(`${res?.responseMessage}`);
        getDataManufacturerList();
        setLoading(false);
        setIsDelete(false);
      } else {
        if (res?.responseMessage) {
          toast.error(res?.responseMessage);
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteStore,
    isLoadding: loading,
  }

  let manufacturerModelProps = {
    isOpen: manufacturerModelData,
    closeModal: (e) => setManufacturerModelData(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: manufacturerModelData?.isDetails ? "View Manufacturer" : (manufacturerModelData?._id ? 'Update Manufacturer' : 'Add Manufacturer'),
    submitTitle: manufacturerModelData?.isDetails ? "View Manufacturer" : (manufacturerModelData?._id ? 'Update Manufacturer' : 'Add Manufacturer'),
    footerPart: manufacturerModelData?.isDetails ? true : false,
    hideFooterSumbmitBtn: manufacturerModelData?.isDetails ? true : false,
    hideCompletelyFoolter: manufacturerModelData?.isDetails ? true : false,
    ApiCall: getDataManufacturerList
  }

  const columns = [
    { header: "Category Name", accessor: "category" },
    { header: "Manufacturer Name", accessor: "manufacturer" },
    { header: "Status", accessor: "status" },
    { header: "Action", accessor: "action" }
  ];

  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      category: <span className='_tblText _style_ancer' onClick={(e) => setManufacturerModelData({ ...item, isDetails: true })}>
        <a className='_avPointer'>
          {item?.category_id?.name ? item?.category_id?.name : '-'} &nbsp;
        </a>
      </span>,
      manufacturer: <>{item?.name ? item?.name : '-'}</>,
      status: <div style={{ color: (item?.status === 1) ? "green" : "red" }}>{item?.status ? constant.ActionStore.find((el) => el?.value === item?.status)?.label : '-'}</div>,
      action: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "100px" }}
        >
          <div
            onClick={(e) => setManufacturerModelData(item)}
            className='_avPointer'
          >
            <span className='_samAnchor'>
              <span className='editIcon_avt'>
                <FiEdit color='blue' />
              </span>
            </span>
            {/* Edit */}
          </div>

          <div
            onClick={(e) => deleteHandler(item)}
            className='_avPointer'
          >
            <span className='_samAnchor'>
              <span className='deleteIcon_avt'>
                <FaRegTrashCan color='red' />
              </span>
            </span>
            {/* Delete */}
          </div>

          <div
            onClick={(e) => submitDeleteStore({ ...item, disable: true })}
            className='_avPointer'
          >
            {/* <span className='_samAnchor'>
              <span className='editIcon_avt'>
                <FiEdit color='blue' />
              </span>
            </span> */}
            {item?.status === 1 ? <CiUnlock color="green" size={20} /> : <CiLock color="red" size={20} />}
            {/* {item?.status === 1 ? 'Disable' : 'Enable'} */}
          </div>
        </div>
      ),
    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }))
  };

  const fetchPartCategory = useCallback(async (search, page, limit) => {
    try {
      const response = await getPartCategoryList({
        company_id: StorageService.getCompanyId(),
        offset: page,
        limit,
        search,
        status: 1
      });

      if (response?.responseCode === 200) {
        const vendors = response.data.partData.map(vendor => ({
          ...vendor,
          label: vendor.name,
          value: vendor._id
        }));

        return {
          items: vendors,
          total: response.data.total_record || vendors.length,
        };
      }

      toast.error(response?.responseMessage);
      return { items: [], total: 0 };
    } catch (error) {
      return { items: [], total: 0 };
    }
  }, []);

  return (
    <div className="__profilCmp_main">
      <ButtonHeading
        title={"Manufacturer"}
        onClick={toggleStoreModelData}
        buttonTitle="Add Manufacturer"
        // buttonTitle={settingChildVehicleGrp?.create === 1 && "Add Vehicle Group"}
        showSearchFilter={{ search: false, filterOption: false, filterCount: true }}
        onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
        filter={filter}
        setFilter={setFilter}
        isDebouncedSearch={true}
      />

      <div className='pd_manufactoer'>
        <div className='__filtsTb_flexMain'>
          <div className='__filtsTb_flex'>
            <div className='__fInx_bx'>
              <CityDropdownForTrip
                label="Select Category * "
                placeholder="Select Category * "
                fetchData={fetchPartCategory}
                pageSize={20}
                selectedItem={filter.category_id ? filter?.category_id : null}
                onChange={(data) => setFilter((s) => ({ ...s, category_id: data }))}
              />
            </div>
            <div className='__fInx_bx'>
              <CommonInput
                type="search"
                label='Search'
                placeholder='Search'
                name='search'
                value={filter.search}
                maxLength="30"
                onInput={utils.maxLengthCheck}
                onChange={(e) => setFilter((s) => ({ ...s, search: e.target.value }))}
              />
            </div>
            {(filter.search || filter?.category_id?.value) ? <div>
              <button
                className='manuRsret'
                onClick={() => setFilter((s) => ({ ...s, search: '', category_id: {} }))}
              >
                Clear
              </button>
            </div> : <></>}
          </div>
        </div>
      </div>
      <div className='_tabWith_outTab'>
        <BootstrapTable
          columns={columns}
          data={rowListData(manufacturerDataList?.length > 0 ? manufacturerDataList : [])}
          // isLoading={loading}
        />

        {manufacturerDataList?.length ? <div className='paginationFt_avt'>
          <CustomPagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={filter.offset}
            onPageChange={handlePageChange}
          />
        </div> : <></>}
      </div>

      {
        manufacturerModelData
        && (
          <AddEditManufacturerModel {...manufacturerModelProps} />
        )
      }

      {
        isDelete?._id && (
          <CommonModal {...propsObject}>
            <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
          </CommonModal>
        )
      }

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? 'visible' : 'hidden' }}
      >
        {showFilterModal &&
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
          />
        }
      </div>
      <div className={showFilterModal ? 'offBack_drop' : ''}></div>

    </div >
  )
}

export default Manufacturer